import * as React from "react";

const Edit: React.FC = () => {
    return <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" color="currentColor" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-266.000000, -237.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(187.000000, 7.000000)">
                    <rect transform="translate(7.511645, 8.413935) rotate(-45.000000) translate(-7.511645, -8.413935) " x="1.86169918" y="6.31395514" width="11.2998916" height="4.19995972"></rect>
                    <polygon transform="translate(13.521000, 2.508900) rotate(-45.000000) translate(-13.521000, -2.508900) " points="12.1210134 0.408920139 14.9209866 0.408920139 14.9209866 4.60887986 12.1210134 4.60887986"></polygon>
                    <polygon points="0 16 3 15 1 13"></polygon>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(Edit);
